import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import MessageComposer from '../MessageComposer';
import '../ThreadQuill.css';
import MessageBubble from '../MessageBubble';
import {
  fetchThread,
  fetchMoreMessages,
  sendReply,
  markThreadRead,
  markConversationUnread,
  clearThread,
  fetchUnreadCount,
} from '../store/conversationsSlice';


const CoachThreadPage = ({ match }) => {
  const { conversationId } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeThread, messages, nextCursor, loading } = useSelector(
    ({ conversations }) => conversations
  );
  const bottomRef = useRef(null);
  const initialScrollDone = useRef(false);

  useEffect(() => {
    dispatch(fetchThread(conversationId));
    dispatch(markThreadRead(conversationId)).then(() => dispatch(fetchUnreadCount()));
    return () => dispatch(clearThread());
  }, [dispatch, conversationId]);

  const scrollToBottom = useCallback((behavior) => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: behavior || 'auto', block: 'end' });
    }
  }, []);

  useEffect(() => {
    if (!initialScrollDone.current && messages.length > 0) {
      scrollToBottom('auto');
      initialScrollDone.current = true;
    }
  }, [messages, scrollToBottom]);

  const handleLoadMore = () => {
    if (nextCursor) dispatch(fetchMoreMessages(conversationId, nextCursor));
  };

  const player = activeThread?.playerProfileId;
  const playerName = player ? `${player.firstName} ${player.lastName}` : 'Player';

  if (loading && !activeThread) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>
        Loading conversation...
      </div>
    );
  }

  return (
    <div style={{ padding: '32px 0' }}>
      <div style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            type="button"
            onClick={() => history.push('/messages')}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#2e496b',
              fontSize: '14px',
              padding: 0,
            }}
          >
            &#8592; Back to Messages
          </button>
          <button
            type="button"
            onClick={async () => {
              await dispatch(markConversationUnread(conversationId));
              history.push('/messages');
            }}
            style={{
              background: 'none',
              border: '1px solid #cbd5e1',
              borderRadius: '4px',
              cursor: 'pointer',
              color: '#64748b',
              fontSize: '12px',
              padding: '4px 10px',
              marginLeft: '16px',
            }}
          >
            Oznacz jako nieprzeczytane
          </button>
        </div>
        <h2 style={{ margin: '8px 0 0', fontSize: '18px', color: '#1e293b' }}>
          {playerName}
          {player?.sport && (
            <span style={{ fontSize: '13px', color: '#64748b', fontWeight: '400', marginLeft: '8px' }}>
              {player.sport}
            </span>
          )}
        </h2>
        {player?.currentClub && (
          <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#94a3b8' }}>
            {player.currentClub}
          </p>
        )}
      </div>

      <div
        style={{
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        {/* Message list */}
        <div style={{ padding: '0' }}>
          {nextCursor && (
            <div style={{ textAlign: 'center', padding: '12px' }}>
              <button
                type="button"
                onClick={handleLoadMore}
                style={{
                  background: 'none',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  padding: '4px 12px',
                  fontSize: '12px',
                  color: '#64748b',
                  cursor: 'pointer',
                }}
              >
                Load earlier messages
              </button>
            </div>
          )}
          {messages.map(msg => {
            let senderLabel;
            if (msg.senderType === 'coach') senderLabel = 'You';
            else if (msg.senderType === 'admin') senderLabel = 'Kajetan Borecki';
            else senderLabel = playerName;

            return (
              <MessageBubble
                key={msg._id}
                message={msg}
                isSentByMe={msg.senderType === 'coach'}
                senderLabel={senderLabel}
                senderType={msg.senderType}
              />
            );
          })}
          <div ref={bottomRef} />
        </div>

        {/* Reply input */}
        <MessageComposer
          threadType="conversations"
          conversationId={conversationId}
          placeholder="Type a message..."
          onSend={({ text, file, draftRevision }) => dispatch(sendReply({ conversationId, text, file, draftRevision }))}
          onSent={() => { setTimeout(() => scrollToBottom('smooth'), 50); }}
        />
      </div>
    </div>
  );
};

export default CoachThreadPage;
